import React from 'react';
import * as DateUtils from 'utils/dates';

const CONFIGURATION = {};

export default CONFIGURATION;

export const TableColumns = [
  {
    label: '#',
    id: 'reminder_received_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Scheme Type',
    id: 'application_type',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Reminder Type',
    id: 'reminder_type',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Originating Country',
    id: 'mscon_country_code',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Message ID',
    id: 'message_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Timestamp',
  //   id: 'timestamp',
  //   align: 'left',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{DateUtils.formatDateTime(cellValue)}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Reminder Date',
    id: 'reminded_date',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DateUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Return Reference',
    id: 'vat_return_reference',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Version',
    id: 'vat_return_version',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const RemindersMsidReceivedTableDefaultFetchValues: ITableDefaultFetchValues =
  {
    TABLE_DEFAULT_PAGE: 0,
    TABLE_DEFAULT_PAGE_SIZE: 25,
    TABLE_DEFAULT_ORDER: 'desc',
    TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
  };
